import { Upload, CheckCircle } from "lucide-react";
import { EXCEL } from "@/constants/testIds";

/**
 * File drag-and-drop / click-to-select upload zone.
 * Props: file (File|null), onChange (fn(File))
 */
export function FileUploader({ file, onChange }) {
  return (
    <label
      data-testid={EXCEL.fileUpload}
      className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer transition-colors ${
        file
          ? "border-green-400 bg-green-50"
          : "border-slate-300 hover:border-[#0D1B3E]/40 hover:bg-slate-50"
      }`}
    >
      <input
        type="file"
        accept=".xlsx,.xls,.csv"
        className="hidden"
        onChange={(e) => e.target.files?.[0] && onChange(e.target.files[0])}
      />
      {file ? (
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle size={20} />
          <span className="text-sm font-medium">{file.name}</span>
        </div>
      ) : (
        <>
          <Upload size={24} className="text-slate-400 mb-2" />
          <span className="text-sm text-slate-500">
            Dosyayı sürükleyin veya tıklayın (.xlsx, .xls, .csv)
          </span>
        </>
      )}
    </label>
  );
}
